<template>
    <div v-title="'每日一题 - 欢乐斗地主'" class="daily-question">
        <div class="wrap">

            <div class="card-wrap">
                <div @click="toReward" v-for="(item,index) in cardList" :key="index" class="card" :class="item.class">
                    <img :src="item.img" alt="牌">
                    <img class="back" src="~assets/daily/7.png" alt="牌背面">
                </div>
            </div>
            <a @click="ShuffleTheCards" class="draw-btn" href="javascript:void (0)"></a>
            <div class="user-wrap">
                <div v-if="!isBind" class="no-Sign">
                    <a @click="getRole" class="sign-btn" href="javascript:void (0)">请绑定</a>
                </div>
                <div v-else class="is-Sign">你好，<span class="user-name">{{characName}}</span><a @click="rebind"
                        class="sign-btn" href="javascript:void (0)">更改</a></div>
            </div>
        </div>

        <div v-if="showReward" class="dialog-reward">
            <div class="reward-wrap">
                <!-- <p class="reward-text">您获得了地主哥准备的【<span class="reward-name">{{rwName}}</span>】大礼一份，赶紧进入游戏查收吧！ </p> -->
                <img class="reward-img" :src="rwImg" alt="奖品图">
                <a class="link" href="http://age.qq.com/weixin/html/huanle_download.html"></a>
                <a @click="showReward = false" class="reward-close" href="javascript:void (0)"></a>
            </div>
        </div>
    </div>
</template>

<script>
    import wxMethods from '@/utils/wxMethods'
    import mtaInitial from '@/utils/mtaInitial'
    import Http from '@/utils/Http'
    import './mobile_rem'
    export default {
        name: 'DailyQuestion',

        mixins: [wxMethods],
        data() {
            return {
                isBind: false,
                characName: '',
                showReward: false,
                shuffleFlag: false, // 是否已经点击洗牌
                shuffleAnimationFlag: false, // 是否在动画中
                isShuffle: false, // 是否已经开始洗牌
                hasReward: false, // 是否已经中奖
                rwName: '',
                rwImg: '',
                cardList: [{
                    class: 'card01',
                    img: require('@/assets/daily/1.png'),
                }, {
                    class: 'card02',
                    img: require('@/assets/daily/2.png'),
                }, {
                    class: 'card03',
                    img: require('@/assets/daily/3.png'),
                }, {
                    class: 'card04',
                    img: require('@/assets/daily/4.png'),
                }, {
                    class: 'card05',
                    img: require('@/assets/daily/5.png'),
                }, {
                    class: 'card06',
                    img: require('@/assets/daily/6.png'),
                }, ],
                gameTool: null
            }
        },
        created() {
            this.wxHideMenu()
            this.initRole()
            this.getRole()
        },

        mounted() {
            mtaInitial(process.env.VUE_APP_MTA_DAYLY_SID, process.env.VUE_APP_MTA_DAYLY_CID)
        },

        methods: {
             initRole() {
				this.gameTool = new GameTools({
					// site: `txy_${GAME}`,
					game: 'hlddz',
					allowPlatForm: ['wx'],
					loginType: 'wx',
				})
		    },
            getRole() {
                this.gameTool.getRole(process.env.VUE_APP_GAME)
                    .then((res) => {
                        if (res.hasRole) {
                            this.isBind = true
                            this.characName = res.roleInfo.charac_name
                            this.checkReward()
                        } else {
                            res.serverSelect.STD_SYSTEM_DATA.length = 2
                            const modal = new GameModal({
                                gameTool: this.gameTool,
                                game: process.env.VUE_APP_GAME,
                                serverSelect: res.serverSelect,
                                confirmText: ' ',
                                showClose: true,
                            })

                            modal.show()

                            modal.afterBind = (isBinded, characName) => {
                                if (isBinded) {
                                    this.isBind = true
                                    this.characName = characName
                                    this.checkReward()
                                    alert('绑定成功')
                                    modal.hide()
                                } else {
                                    alert('未查询到角色')
                                }
                            }
                             modal.afterUnBind = (isUnBinded) => {
                                if (isUnBinded) {
                                    this.isBind = false
                                    this.characName = ''
                                    modal.hide()
                                    alert('解绑成功')
                                }else{
                                    alert('解绑失败，请重试')
                                }
                            }
                        }
                    })
            },

            rebind() {
                if (this.binding || this.loading) return
                this.binding = true
                this.gameTool.getServerSelect(process.env.VUE_APP_GAME).then((serverSelect) => {
                    serverSelect.STD_SYSTEM_DATA.length = 2
                    this.binding = false
                    const modal = new GameModal({
                        gameTool: this.gameTool,
                        game: process.env.VUE_APP_GAME,
                        serverSelect,
                        confirmText: ' ',
                        showClose: true,
                    })
                    modal.show()
                    modal.afterBind = (isBinded, characName) => {
                        if (isBinded) {
                            this.isBind = true
                            this.characName = characName
                            modal.hide()
                            alert('绑定成功')
                        } else {
                            alert('未查询到角色')
                        }
                    }
                    modal.afterUnBind = (isUnBinded) => {
                                if (isUnBinded) {
                                    modal.hide()
                                    this.isBind = false
                                    this.characName = ''
                                    alert('解绑成功')
                                }else{
                                    alert('解绑失败，请重试')
                                }
                    }
                })
            },

            // 查询抽奖资格接口
            checkReward() {
                Http.post({
                        path: 'daily_qa/reward/valid',
                        params: {
                            game: process.env.VUE_APP_GAME
                        },
                    })
                    .then((res) => {
                        this.code = res.code
                        if (res.code !== 200) {
                            this.msg = res.msg
                        }
                    })
                    .catch((err) => {
                        // console.warn('error', err)
                        this.code = err.code
                        this.msg = err.msg
                    })
            },

            // 抽奖接口
            reward() {
                if (this.hasReward) {
                    alert('一人一天只能抽奖一次哦～')

                } else {
                    this.loading = true;
                    Http.post({
                            path: 'daily_qa/reward/get',
                            params: {
                                game: process.env.VUE_APP_GAME
                            },
                        })
                        .then((res) => {
                            this.loading = false
                            if (res.code === 200) {
                                this.rwLists(res.result.package_id)
                                this.showReward = true;
                                $('.dialog-reward').show();
                                setTimeout(() => {
                                    this.loading = false
                                    this.hasReward = true
                                }, 300)
                            } else if (res.code === 202) {
                                this.loading = false
                                alert(res.msg)
                                this.hasReward = true
                            } else {
                                this.loading = false
                                alert(res.msg)
                            }
                        })
                        .catch((err) => {
                            this.loading = false
                            alert(err.msg)
                            console.warn('error', err)
                        })
                }
            },

            // 抽奖
            toReward() {
                if (this.isShuffle || this.binding || this.loading) return
                if (this.isBind) {
                    if (this.code === 200) {
                        if (!this.shuffleFlag) {
                            alert('请先点击翻牌')
                            return
                        }
                        this.reward()
                    } else {
                        alert(this.msg ? this.msg : '服务器繁忙，请稍后再试')
                    }
                } else {
                    this.getRole()
                }
            },

            // 开始洗牌
            ShuffleTheCards() {
                if (this.shuffleAnimationFlag || this.loading) return
                if (this.isBind) {
                    if (this.code === 200) {
                        if (this.hasReward) {
                            alert('一人一天只能抽奖一次哦～')
                            return
                        }
                        if (this.shuffleAnimationFlag || this.loading) return
                        if (this.shuffleFlag) {
                            alert('请点击牌领取奖励')
                            return
                        }
                        this.isShuffle = true
                        this.shuffleAnimationFlag = true
                        this.cardAnimation(() => {
                            this.shuffleAnimationFlag = false
                            this.shuffleFlag = true
                            this.isShuffle = false
                        })
                    } else {
                        alert(this.msg ? this.msg : '服务器繁忙，请稍后再试')
                    }
                } else {
                    this.getRole()
                }
            },
            // 奖品列表
            rwLists(rwId) {
                switch (rwId) {
                    case '1418378':
                        this.rwName = '记牌器',
                            this.rwImg = require('@/assets/daily/p1.png')
                        break
                    case '1418434':
                        this.rwName = '超级加倍',
                            this.rwImg = require('@/assets/daily/p2.png')
                        break
                    case '1418436':
                        this.rwName = '欢乐豆', // 500
                            this.rwImg = require('@/assets/daily/p3.png')
                        break
                    case '1418438':
                        this.rwName = '福卡',
                            this.rwImg = require('@/assets/daily/p4.png')
                        break
                    case '1418449':
                        this.rwName = '招财猫',
                            this.rwImg = require('@/assets/daily/p5.png')
                        break
                    case '1418459':
                        this.rwName = '欢乐豆', // 1500
                            this.rwImg = require('@/assets/daily/p6.png')
                        break
                    default:
                        break
                }
            },

            // 洗牌动画
            cardAnimation(cb) {
                $('.card').addClass('back')
                setTimeout(() => {
                    startShuffle()
                    setTimeout(() => {
                        endShuffle()
                        setTimeout(() => {
                            cb()
                        }, 800)
                    }, 1000)
                }, 500)

                function reordering(arr) {
                    const length = arr.length
                    const arrNew = []
                    for (let i = 0; i < length; i++) {
                        const random = Math.floor(Math.random() * (length - i))
                        arrNew.push(arr.splice(random, 1)[0])
                    }
                    return arrNew
                }

                function startShuffle() {
                    const clength = $('.card').length
                    let a = []
                    for (let i = 0; i < clength; i++) {
                        a.push(i)
                    }
                    a = reordering(a)

                    $('.card').each((index) => {
                        setTimeout(() => {
                            $('.card').eq(a[index]).addClass('card07')
                            $('.card').eq(a[index]).css('z-index', index)
                        }, index * 100)
                    })
                }

                function endShuffle() {
                    const clength = $('.card').length
                    $('.card').each((index) => {
                        $('.card').eq(index).css('z-index', clength - index)
                    })
                    setTimeout(() => {
                        $('.card').each((index) => {
                            setTimeout(() => {
                                $('.card').eq(index).removeClass('card07')
                            }, index * 100)
                        })
                    }, 10)
                }
            },
        },
    }
</script>

<style src="./DailyQuestion.scss" lang="scss"></style>